export default __webpack_public_path__ + "static/media/loader2.7b5a1cf6.gif";